import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  Button,
  CustomInput,
  Description,
  Title,
} from "../../Components/CustomComponents";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import { useForgotPasswordMutation } from "../../Data/services/userAuthApi";
import Toast from "../../Hooks/useToast";
import { ACCOUNT_ENUM } from "./Route";

export default function ForgotPassword({ setPage }) {
  const { handleSubmit, control, register } = useForm();
  const navigate = useNavigate();
  const handleBackButtonClick = () => {
    setPage(ACCOUNT_ENUM.LOGIN);
  };

  const [ForgetPassword, { data, isSuccess, isLoading }] =
    useForgotPasswordMutation();

  const handleDataSubmit = async (userData) => {
    try {
      // Use unwrap() to get the response data directly
      const response = await ForgetPassword(userData).unwrap();
      Toast(response?.message, "success");
      // dispatch(updateLogin(true))
      navigate("/account");
    } catch (error) {
      console.log(error?.data?.message, "errrrr");
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  return (
    <AccountLayout
      hasBackButton={true}
      handleBackButton={handleBackButtonClick}
    >
      <Title text="Forgot Password" classes="mb-2" />
      <Description
        text="In order to reset your password you need to enter your registered email address."
        classes="text-center fs-7"
      />
      <Form onSubmit={handleSubmit(handleDataSubmit)}>
        <Controller
          control={control}
          name="email"
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                placeholder="Email"
                type="email"
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Button
          text={<>{isLoading ? <LoadingButton /> : "Continue"}</>}
          classes="mt-3 mb-2"
          disabled={isLoading}
          type="submit"
        />
      </Form>
    </AccountLayout>
  );
}
